import { FieldValues, UseFormWatch } from 'react-hook-form';

import { useCountries, usePostalCode } from 'hooks';

import { FormItem } from 'sections/EditForm';

const useFormData = (watch: UseFormWatch<FieldValues>): FormItem[] => {
  const country = watch && watch('shippingAddress.country');

  const { countryCode, countryList } = useCountries(country);

  const { postalCodes } = usePostalCode(countryCode!);

  return [
    {
      label: 'At',
      name: 'shippingAddress.presso',
    },
    {
      label: 'Country',
      type: 'select',
      options: countryList,
      name: 'shippingAddress.country',
    },
    {
      label: 'State',
      name: 'shippingAddress.region',
    },
    {
      label: 'Post Code',
      name: 'shippingAddress.postCode',
      options: postalCodes,
      type: 'postCodeSelect',
    },
    {
      label: 'Address',
      name: 'shippingAddress.street',
    },
    {
      label: 'City',
      name: 'shippingAddress.city',
    },
    {
      label: 'Province',
      name: 'shippingAddress.province',
    },
    {
      label: 'Mobile Number',
      name: 'shippingAddress.mobileNumber',
    },
    {
      label: 'Home Number',
      name: 'shippingAddress.phoneNumber',
    },
  ];
};

export { useFormData };
